import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { buildComponentName } from '../utils';
import { getSlotOrValue } from './utils';
import SubMixin from './mixins/sub';
import Row from '../grid';
var defaultLabelCol = {
  xs: 24,
  sm: 8
};
var defaultWrapperCol = {
  xs: 24,
  sm: 16
};
export default {
  name: buildComponentName('FormItem'),
  mixins: [SubMixin],
  provide: function provide() {
    return {
      formItemNode: this
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    },
    required: {
      type: Boolean,
      default: null
    },
    colon: {
      type: Boolean,
      default: false
    },
    help: {
      type: String,
      default: ''
    },
    extra: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      hasError: false,
      fields: []
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      return "".concat(this.rootPrefixCls, "-item");
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          colon = this.colon;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-no-colon"), !colon), _ref;
    },
    normalizeLabelCol: function normalizeLabelCol() {
      var formLayout = this.formLayout,
          labelCol = this.labelCol;
      var col = {};

      if (formLayout === 'horizontal') {
        col = _objectSpread({}, defaultLabelCol);
      }

      return _objectSpread({}, col, {}, labelCol);
    },
    normalizeWrapperCol: function normalizeWrapperCol() {
      var formLayout = this.formLayout,
          wrapperCol = this.wrapperCol;
      var col = {};

      if (formLayout === 'horizontal') {
        col = _objectSpread({}, defaultWrapperCol);
      }

      return _objectSpread({}, col, {}, wrapperCol);
    },
    isRequired: function isRequired() {
      var required = this.required,
          fields = this.fields;

      if (required !== null) {
        return required;
      }

      return fields.some(function (v) {
        return v.field && v.field.isRequired;
      });
    }
  },
  methods: {
    getExtraInfo: function getExtraInfo() {
      return getSlotOrValue('extra', this);
    },
    addItemField: function addItemField(field) {
      var fields = this.fields,
          addFormField = this.addFormField;
      fields.push(field);
      addFormField(field);
    },
    removeItemField: function removeItemField(field) {
      var fields = this.fields,
          removeFormField = this.removeFormField;
      this.fields = fields.filter(function (v) {
        return v !== field;
      });
      removeFormField(field);
    },
    setHasError: function setHasError(isError) {
      this.hasError = isError;
    },
    renderLabel: function renderLabel() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          isVerticalForm = this.isVerticalForm,
          id = this.id,
          normalizeLabelCol = this.normalizeLabelCol,
          isRequired = this.isRequired,
          colon = this.colon;

      var labelClass = _defineProperty({}, "".concat(prefixCls, "-required"), isRequired);

      var labelElement = getSlotOrValue('label', this);

      if (colon && isVerticalForm && typeof labelElement === 'string' && labelElement.trim() !== '') {
        labelElement = labelElement.replace(/[：|:]\s*$/, '');
      }

      return labelElement ? h(Row.Col, _mergeJSXProps([{}, {
        class: ["".concat(prefixCls, "-label"), (normalizeLabelCol || {}).className],
        props: normalizeLabelCol
      }]), [h("label", {
        "attrs": {
          "htmlFor": id,
          "title": typeof labelElement === 'string' ? labelElement : ''
        },
        "class": labelClass
      }, [labelElement])]) : null;
    },
    renderHelp: function renderHelp() {
      var h = this.$createElement;
      var rootPrefixCls = this.rootPrefixCls,
          hasError = this.hasError;
      var help = getSlotOrValue('help', this);
      return help && !hasError ? h("div", {
        "class": "".concat(rootPrefixCls, "-explain"),
        "key": "help"
      }, [help]) : null;
    },
    renderExtra: function renderExtra() {
      var h = this.$createElement;
      var rootPrefixCls = this.rootPrefixCls,
          getExtraInfo = this.getExtraInfo;
      var extra = getExtraInfo();
      return extra ? h("div", {
        "class": "".concat(rootPrefixCls, "-extra")
      }, [extra]) : null;
    },
    renderWrapper: function renderWrapper() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          normalizeWrapperCol = this.normalizeWrapperCol,
          $slots = this.$slots,
          renderHelp = this.renderHelp,
          renderExtra = this.renderExtra;
      return h(Row.Col, _mergeJSXProps2([{}, {
        class: ["".concat(prefixCls, "-control-wrapper"), (normalizeWrapperCol || {}).className],
        props: normalizeWrapperCol
      }]), [h("div", {
        "class": "".concat(prefixCls, "-control")
      }, [[$slots.default, renderHelp(), renderExtra()]])]);
    },
    renderChildren: function renderChildren() {
      var renderLabel = this.renderLabel,
          renderWrapper = this.renderWrapper;
      return [renderLabel(), renderWrapper()];
    },
    renderFormItem: function renderFormItem() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          classes = this.classes,
          hasError = this.hasError,
          renderChildren = this.renderChildren;
      var help = getSlotOrValue('help', this);
      var itemCls = [classes, _defineProperty({}, "".concat(prefixCls, "-with-help"), hasError || help)];
      return h(Row, {
        "class": itemCls
      }, [renderChildren()]);
    }
  },
  render: function render() {
    var renderFormItem = this.renderFormItem;
    return renderFormItem();
  }
};